import { render, staticRenderFns } from "./nextProduction.vue?vue&type=template&id=007252fc&scoped=true"
import script from "./nextProduction.vue?vue&type=script&lang=js"
export * from "./nextProduction.vue?vue&type=script&lang=js"
import style0 from "./nextProduction.vue?vue&type=style&index=0&id=007252fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007252fc",
  null
  
)

export default component.exports